export default __webpack_public_path__ + "dist/media/Lock.301662d8.svg";